import React, {Component} from 'react';
import { connect } from 'react-redux';

import { isEventPackageFeatureEnabled, FARMAOVCITERASYKARAVANY_HOTEL_ID, SANDAMIANO_HOTEL_ID } from './utils';

export function translate(translations, language, id, data = null, html = false) {
	if (translations && translations[language] && (Array.isArray(id) || translations[language][id])) {

		const translated = [];

		// Pokud se jedná o jednoduchý string, převedeme na "standardní" formát pole, kde položky typu string se bez
		// překladu přidávají do výsledného řetězce a položky typu pole se překládají
		if (typeof id === 'string') {
			id = [[id]];
		}

		// Pro vybrané hotely/situace chceme mít některé překlady jiné
		const urlParams = new URLSearchParams(window.location.search);
		const hotelId = urlParams.get('hotelId');

		let hotelPostfixId = '';
		if (hotelId === SANDAMIANO_HOTEL_ID) {
			hotelPostfixId = '|sandamiano';
		}

		let featurePostfixId = '';
		if (hotelId === FARMAOVCITERASYKARAVANY_HOTEL_ID) {
			featurePostfixId = '|caravanSite';
		} else if (urlParams.get('packageId') && isEventPackageFeatureEnabled(hotelId)) {
			featurePostfixId = '|event';
		}

		// Projdeme jednotlivé položky pole
		for (let idPart of id) {

			// Pokud se jedná o string, přidáme do výsledného pole a procházíme dále.
			if (typeof idPart === 'string') {
				translated.push(idPart);
				continue;
			}

			// Jedná se o pole. První prvek je ID překladu a druhý, volitelný, může být objekt (data) s proměnnými
			// pro nahrazení v překladu.
			const translationId = idPart[0];
			const translationData = data || idPart[1];

			let translation = (hotelPostfixId && translations[language][translationId + hotelPostfixId])
				|| (featurePostfixId && translations[language][translationId + featurePostfixId])
				|| translations[language][translationId];

			// Pokud neexistuje překlad, přidáme do výsledku překladový string.
			if (!translation) {
				translated.push(translationId);
				continue;
			}

			// Zpracování skloňování plurálů
			if (translationData && translationData.hasOwnProperty('count')) {
				translation = translation.split('|');

				if (translation.length === 3) {
					// singular, few and many - např. čeština
					if (translationData.count === 1) {
						translation = translation[0];
					} else if (translationData.count < 5) {
						translation = translation[1];
					} else {
						translation = translation[2];
					}

				} else if (translation.length === 2) {
					// singular and plurar - např. angličtina
					if (translationData.count === 1) {
						translation = translation[0];
					} else {
						translation = translation[1];
					}

				} else {
					// množné číslo není zadáno
					translation = translation[0];
				}
			}

			// Nahrazení proměnných skutečnými hodnotami
			if (translationData) {
				Object.keys(translationData).forEach(item => translation = translation.replace(new RegExp('%' + item + '%', 'g'), translationData[item]))
			}

			translated.push(translation);
		}

		if (html) {
			return <span dangerouslySetInnerHTML={{__html: translated.join('')}}/>;
		}

		return translated.join('');

	} else if (id) {
		return id;
	}

	return `Missing translation`;
}

export function addNonBreakingSpaces(text) {
	if (!text || typeof text !== 'string') return text;
	const pattern = /(^|\s)(\S{1,3}) /g;
	text = text.replace(pattern, '$1$2\u00A0');
	text = text.replace(pattern, '$1$2\u00A0');
	return text;
}

export function translatePropertyValue(translations, language) {
	return translations[language] || translations.en || Object.values(translations)[0] || null;
}

export function translateSelectOptions(translations, language, options) {
	const translatedOptions = [];

	for (let option of options) {
		translatedOptions.push({
			value: option.value,
			label: translate(translations, language, option.label)
		});
	}

	return translatedOptions;
}

export default function withLocalize(WrappedComponent) {
	class LocalizedComponent extends Component {

		translate = (id, data, html = false) => {
			const { lang, translations } = this.props;

			return translate(translations, lang, id, data, html);
		};

		translatePropertyValue = (translations) => {
			const { lang } = this.props;

			return translatePropertyValue(translations, lang);
		};

		translateSelectOptions = (options) => {
			const { lang, translations } = this.props;

			return translateSelectOptions(translations, lang, options);
		};

		render() {

			const props = {
				...this.props,
				translate: this.translate,
				translatePropertyValue: this.translatePropertyValue,
				translateSelectOptions: this.translateSelectOptions,
			};

			if (!WrappedComponent) {
				return null;
			}

			return (
				<WrappedComponent {...props} />
			);
		}
	}

	const mapStateToProps = (state) => ({
		translations: state.app.translations,
		lang: state.app.lang,
	});

	return connect(mapStateToProps)(LocalizedComponent);
}


// WEBPACK FOOTER //
// ./src/withLocalize.js